/**
 * BusinessExtractosOla — wrapper Business-only para Statements/Statement compartidos.
 * Remapea chrome bajo .extractos-ola sin tocar el styling de personas
 * (/dashboard/statements). Solo chrome; list/API/PDF intactos.
 */
import Statements from '../Statements';
import Statement from '../Statement';

export function BusinessExtractosList() {
  return (
    <div className="extractos-ola">
      <Statements />
    </div>
  );
}

export function BusinessExtractosDetail() {
  return (
    <div className="extractos-ola">
      <Statement />
    </div>
  );
}
